const $ = require('cash-dom');

const Annotations = {
  init() {
    this._initAnnotations();

    $(window).on('resize', this._initAnnotations);
    $(window).on('load', this._initAnnotations);
  },

  _initAnnotations: function () {
    var imgAnnotaionI = 0;
    $('[data-annotation-x]').each(function () {
      var $annotation = $(this);
      var $img;

      $annotation.prevAll('*').each(function () {
        if ($(this).get(0).tagName.toLowerCase() === 'img') {
          $img = $(this);
          return false;

        } else if ($(this).find('img').length > 0) {
          $img = $(this).find('img').last();
          return false;
        }
      });

      if (typeof $img === 'undefined' || $img.length === 0) {
        $annotation.parent().prevAll('*').each(function () {
          if ($(this).get(0).tagName.toLowerCase() === 'img') {
            $img = $(this);
            return false;

          } else if ($(this).find('img').length > 0) {
            $img = $(this).find('img').last();
            return false;
          }
        });
      }

      if (typeof $img === 'undefined' || $img.length === 0) {
        return;
      }

      var imgAnnotationId = 'img-annotations-' + imgAnnotaionI;
      if (typeof $img.data('annotations') === 'undefined') {
        $img.data('annotations', imgAnnotationId);

        var timeout = null;
        $img.on('mouseenter', function () {
          var $this = $(this);
          clearTimeout(timeout);
          var imgAnnotationId = $this.data('annotations');
          var $annotations = $('[data-img="' + imgAnnotationId + '"]');
          $annotations.addClass('active');

          $annotations
            .off('mouseenter')
            .on('mouseenter', function () {
              clearTimeout(timeout);
            })
            .off('mouseout')
            .on('mouseout', function () {
              $this.mouseout();
            });
        }).on('mouseout', function () {
          var $this = $(this);
          clearTimeout(timeout);
          timeout = setTimeout(function () {
            var imgAnnotationId = $this.data('annotations');
            var $annotations = $('[data-img="' + imgAnnotationId + '"]');
            $annotations.removeClass('active');
          }, 1000);
        });
        imgAnnotaionI++;
      }

      var imgX = $img.position().left;
      var imgY = $img.position().top;

      var imgW = $img.width();
      var imgH = $img.height();
      var annotationX = $annotation.data('annotation-x');
      var annotationY = $annotation.data('annotation-y');

      if (annotationX.toString().indexOf('%') !== -1) {
        annotationX = (imgW / 100 * +annotationX.replace('%', ''));
      } else if (annotationX.toString().indexOf('px') !== -1) {
        annotationX = +annotationX.replace('px', '');
      } else {
        annotationX = +annotationX;
      }

      if (annotationY.toString().indexOf('%') !== -1) {
        annotationY = (imgH / 100 * +annotationY.replace('%', ''));
      } else if (annotationY.toString().indexOf('px') !== -1) {
        annotationY = +annotationY.replace('px', '');
      } else {
        annotationY = +annotationY;
      }

      if (annotationX >= 0) {
        annotationX += imgX;
      } else {
        annotationX += imgX + imgW;
      }

      if (annotationY >= 0) {
        annotationY += imgY;
      } else {
        annotationY += imgY + imgH;
      }


      $annotation.css({
        top: annotationY,
        left: annotationX
      }).attr({
        'data-img': imgAnnotationId
      });

    });
  },
};

module.exports = Annotations;

